import { createSlot } from "lib/@components/slot/create-slot"

export const RegisterItem = createSlot("RegisterItem")
